import React from "react";
import { motion } from "framer-motion";

const AbstractPointGraph = () => {
  const i = 8;
  return (
    <svg
      overflow="visible"
      viewBox="0 0 2000.44 648.89"
    >
      <style>
        {
          ".prefix__st0{fill:none;stroke:#540014;stroke-miterlimit:10}.prefix__st2{fill:#3F0A16}"
        }
      </style>
      <path
        d="M.23 648.2l564.59-260.93 945.63 160.05L1975.66 3.5"
        className="prefix__st0 drawIn"
        // style={{ animationDelay: `1s` }}
      />
      <path
        d="M1975.66 3.5l-41.58 560.41L919.49 377.3 596.21 622.93"
        className="prefix__st0 drawIn"
        // style={{ animationDelay: `3s` }}
      />
      <path
        d="M244.6 648.2l482.87-312.92 468.48 241.43 141.93-439.07 662.35 114.18"
        className="prefix__st0 drawIn"
        // style={{ animationDelay: `5s` }}
      />
      <path
        d="M.23 648.2l544.14-289.17L922.92 648.2l414.96-510.56 662.35-3.71"
        className="prefix__st0 drawIn"
        // style={{ animationDelay: `7s` }}
      />
      <path
        d="M2000.23 116.94l-464.76-47.07-808 561.04-291.43-214.3L.23 648.2"
        className="prefix__st0 drawIn"
        // style={{ animationDelay: `9s` }}
      />
      <path
        d="M2000.23 391.79l-397.91-181.87-257.02 377.93L919.49 377.3 399.31 648.2"
        className="prefix__st0 drawIn"
        // style={{ animationDelay: `11s` }}
      />
      <path
        d="M1975.66 3.5l-280.63 445.12-775.54-71.32L145.1 648.2"
        className="prefix__st0 drawIn"
        // style={{ animationDelay: `12s` }}
      />
      <path
        d="M919.49 377.3l159.5 78.87 129.35-159.15-135.66 94.04zm871.62-81.09l-47.34-21.64 225.31-263.39z"
        opacity={0.26}
        fill="#490B17"
        className="fadeInCircle"
      />

      {/* Circles That Fade In */}
      <circle
        cx={1072.68}
        cy={391.06}
        r={5.54}
        className="prefix__st2 fadeInCircle"
        style={{ animationDelay: `${i}*1s` }}
      />
      <circle
        cx={1044.62}
        cy={498.4}
        r={5.54}
        className="prefix__st2 fadeInCircle"
        style={{ animationDelay: `${i}*1s` }}
      />
      <circle
        cx={920.49}
        cy={377.59}
        r={5.54}
        className="prefix__st2 fadeInCircle"
        style={{ animationDelay: `${i}*1s` }}
      />
      <circle
        cx={743.64}
        cy={511.93}
        r={5.54}
        className="prefix__st2 fadeInCircle"
        style={{ animationDelay: `${i}*1s` }}
      />
      <circle
        cx={728.06}
        cy={335.73}
        r={5.54}
        className="prefix__st2 fadeInCircle"
        style={{ animationDelay: `${i}*1s` }}
      />
      <circle
        cx={610.75}
        cy={411.3}
        r={5.54}
        className="prefix__st2 fadeInCircle"
        style={{ animationDelay: `${i}*1s` }}
      />
      <circle
        cx={1338.18}
        cy={138.64}
        r={5.54}
        className="prefix__st2 fadeInCircle"
        style={{ animationDelay: `${i}*1s` }}
      />
      <circle
        cx={1601.87}
        cy={209.92}
        r={5.54}
        className="prefix__st2 fadeInCircle"
        style={{ animationDelay: `${i}*1s` }}
      />
      <circle
        cx={1694.67}
        cy={447.96}
        r={5.54}
        className="prefix__st2 fadeInCircle"
        style={{ animationDelay: `${i}*1s` }}
      />
      <circle
        cx={1251.97}
        cy={407.76}
        r={5.54}
        className="prefix__st2 fadeInCircle"
        style={{ animationDelay: `${i}*1s` }}
      />
      <circle
        cx={1975.66}
        cy={6.04}
        r={5.54}
        className="prefix__st2 fadeInCircle"
        style={{ animationDelay: `${i}*1s` }}
      />
      <circle
        cx={1836.64}
        cy={224}
        r={5.54}
        className="prefix__st2 fadeInCircle"
        style={{ animationDelay: `${i}*1s` }}
      />
      <circle
        cx={1510.81}
        cy={546.23}
        r={5.54}
        className="prefix__st2 fadeInCircle"
        style={{ animationDelay: `${i}*1s` }}
      />
      <circle
        cx={1455.97}
        cy={426.52}
        r={5.54}
        className="prefix__st2 fadeInCircle"
        style={{ animationDelay: `${i}*1s` }}
      />
      {/* Circles that DrawIn */}
      <circle
        cx={1072.68}
        cy={391.06}
        r={5.54}
        className="prefix__st0 drawInCircle"
        style={{ animationDelay: `${i}*1s` }}
      />
      <circle
        cx={1044.62}
        cy={498.4}
        r={5.54}
        className="prefix__st0 drawInCircle"
        style={{ animationDelay: `${i}*1s` }}
      />
      <circle
        cx={920.49}
        cy={377.59}
        r={5.54}
        className="prefix__st0 drawInCircle"
        style={{ animationDelay: `${i}*1s` }}
      />
      <circle
        cx={743.64}
        cy={511.93}
        r={5.54}
        className="prefix__st0 drawInCircle"
        style={{ animationDelay: `${i}*1s` }}
      />
      <circle
        cx={728.06}
        cy={335.73}
        r={5.54}
        className="prefix__st0 drawInCircle"
        style={{ animationDelay: `${i}*1s` }}
      />
      <circle
        cx={610.75}
        cy={411.3}
        r={5.54}
        className="prefix__st0 drawInCircle"
        style={{ animationDelay: `${i}*1s` }}
      />
      <circle
        cx={1338.18}
        cy={138.64}
        r={5.54}
        className="prefix__st0 drawInCircle"
        style={{ animationDelay: `${i}*1s` }}
      />
      <circle
        cx={1601.87}
        cy={209.92}
        r={5.54}
        className="prefix__st0 drawInCircle"
        style={{ animationDelay: `${i}*1s` }}
      />
      <circle
        cx={1694.67}
        cy={447.96}
        r={5.54}
        className="prefix__st0 drawInCircle"
        style={{ animationDelay: `${i}*1s` }}
      />
      <circle
        cx={1251.97}
        cy={407.76}
        r={5.54}
        className="prefix__st0 drawInCircle"
        style={{ animationDelay: `${i}*1s` }}
      />
      <circle
        cx={1975.66}
        cy={6.04}
        r={5.54}
        className="prefix__st0 drawInCircle"
        style={{ animationDelay: `${i}*1s` }}
      />
      <circle
        cx={1836.64}
        cy={224}
        r={5.54}
        className="prefix__st0 drawInCircle"
        style={{ animationDelay: `${i}*1s` }}
      />
      <circle
        cx={1510.81}
        cy={546.23}
        r={5.54}
        className="prefix__st0 drawInCircle"
        style={{ animationDelay: `${i}*1s` }}
      />
      <circle
        cx={1455.97}
        cy={426.52}
        r={5.54}
        className="prefix__st0 drawInCircle"
        style={{ animationDelay: `${i}*1s` }}
      />
    </svg>
  );
};

export default AbstractPointGraph;
